/* Copys das paginas de apoio da loja, servidas de fora da loja.
 *
 * Irmao do ui-team-names.js, um degrau acima: la o Worker manda NOME DE TIME, aqui manda
 * PARAGRAFO INTEIRO. Existe pelo mesmo motivo - o texto das paginas "Our Store", "About Us"
 * e da central de ajuda fala de camisa, clube e liga, e enquanto ele morava no editor de
 * tema ia gravado no templates/page.*.json e saia literal no HTML que a Shopify serve.
 *
 * CONTRATO COM O TEMA. O elemento nasce VAZIO com o codigo, e o texto vem daqui:
 *
 *   data-ui-html="OS1"  -> escreve com innerHTML  (texto rico: <p>, <br>, <strong>)
 *   data-ui-txt="OS1"   -> escreve com textContent (texto puro: rotulo de botao, titulo)
 *
 * Nascer vazio e o ponto: se o codigo fosse impresso e trocado depois, o cliente veria
 * "[[MD:OS1]]" piscar. Quem decide isso e a section (rich-text, image-with-text, ui-faq),
 * que reconhece o marcador no campo do editor e imprime o atributo no lugar do texto.
 *
 * SEM defer, de proposito, pela mesma razao do ui-team-names.js: o MutationObserver e
 * instalado DURANTE o parse do HTML, entao na visita repetida (dicionario no localStorage)
 * o texto ja esta no elemento antes do primeiro paint. Com defer, a pagina apareceria
 * vazia e o texto entraria depois, empurrando o resto.
 *
 * A rota /textos e separada do /teams: o /teams e buscado em toda pagina da loja e as
 * copys so interessam a estas tres. Buscar aqui custa zero pra quem nao tem marcador -
 * o fetch so dispara quando o primeiro elemento marcado aparece.
 *
 * O dicionario nao mora no tema: a URL vem do data-ui-labels no <html>.
 */
(function () {
  "use strict";

  var ATTR_HTML = "data-ui-html";
  var ATTR_TXT = "data-ui-txt";
  var DONE = "data-ui-textos";
  var CHAVE = "ui_textos_v1";
  var VALIDADE = 86400000; /* 24h, igual ao Cache-Control do Worker */

  var MAPA = null;
  var buscando = false;
  var fila = [];

  function base() {
    var url = document.documentElement.getAttribute("data-ui-labels");
    return url ? url.replace(/\/+$/, "") : null;
  }

  function lerCache() {
    try {
      var cru = localStorage.getItem(CHAVE);
      if (!cru) return null;
      var obj = JSON.parse(cru);
      if (!obj || !obj.t || !obj.d) return null;
      if (Date.now() - obj.t > VALIDADE) return null;
      return obj.d;
    } catch (e) {
      return null;
    }
  }

  function gravarCache(dados) {
    try {
      localStorage.setItem(CHAVE, JSON.stringify({ t: Date.now(), d: dados }));
    } catch (e) {
      /* modo privado ou cota cheia: segue sem cache, so custa um request por visita */
    }
  }

  function aplicarMapa(dados, revalidando) {
    var mudou = MAPA && JSON.stringify(MAPA) !== JSON.stringify(dados);
    MAPA = dados;
    if (revalidando && mudou) {
      /* copy nova no ar: reescreve o que ja esta na tela, inclusive o que ficou sem texto */
      var jaFeitos = document.querySelectorAll("[" + DONE + "]");
      for (var i = 0; i < jaFeitos.length; i++) jaFeitos[i].removeAttribute(DONE);
      varrer(document);
    }
    var pendentes = fila;
    fila = [];
    for (var j = 0; j < pendentes.length; j++) preencher(pendentes[j]);
  }

  /* Busca o dicionario. Com cache local valido, entrega na hora e revalida em segundo
     plano com cache: "no-cache" - sem isso o navegador serviria a copia dele sem
     perguntar nada ao Worker, e a copy nova so apareceria 24h depois. O Worker responde
     304 sem corpo quando a versao ja e a certa, entao conferir custa quase nada. */
  function garantir() {
    if (MAPA || buscando) return;
    var url = base();
    if (!url) return;
    buscando = true;

    var local = lerCache();
    if (local) {
      aplicarMapa(local, false);
      fetch(url + "/textos", { cache: "no-cache" })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (dados) {
          if (dados) {
            gravarCache(dados);
            aplicarMapa(dados, true);
          }
        })
        .catch(function () {});
      return;
    }

    fetch(url + "/textos")
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (dados) {
        if (!dados) {
          liberarFila();
          return;
        }
        gravarCache(dados);
        aplicarMapa(dados, false);
      })
      .catch(function () {
        liberarFila();
      });
  }

  /* Worker fora do ar: marca os elementos pra nao ficarem presos na fila. Eles continuam
     vazios, que e melhor que mostrar o codigo cru. */
  function liberarFila() {
    var pendentes = fila;
    fila = [];
    for (var i = 0; i < pendentes.length; i++) pendentes[i].setAttribute(DONE, "sem-texto");
  }

  function preencher(el) {
    var comHtml = el.hasAttribute(ATTR_HTML);
    var codigo = comHtml ? el.getAttribute(ATTR_HTML) : el.getAttribute(ATTR_TXT);
    var texto = MAPA ? MAPA["t:" + codigo] : null;
    if (!texto) {
      el.setAttribute(DONE, "sem-texto");
      return;
    }
    if (comHtml) {
      if (el.innerHTML !== texto) el.innerHTML = texto;
    } else if (el.textContent !== texto) {
      el.textContent = texto;
    }
    el.setAttribute(DONE, "1");
  }

  function tratar(el) {
    if (!el || el.nodeType !== 1 || el.hasAttribute(DONE)) return;
    if (!el.hasAttribute(ATTR_HTML) && !el.hasAttribute(ATTR_TXT)) return;
    garantir();
    if (!MAPA) {
      fila.push(el);
      return;
    }
    preencher(el);
  }

  function varrer(raiz) {
    if (!raiz || !raiz.querySelectorAll) return;
    if (raiz.nodeType === 1) tratar(raiz);
    var achados = raiz.querySelectorAll("[" + ATTR_HTML + "], [" + ATTR_TXT + "]");
    for (var i = 0; i < achados.length; i++) tratar(achados[i]);
  }

  /* Observa durante o parse: cada elemento marcado e tratado assim que nasce, e nao no
     fim da pagina. E o que evita a pagina aparecer vazia na visita repetida. */
  new MutationObserver(function (lista) {
    for (var i = 0; i < lista.length; i++) {
      var nos = lista[i].addedNodes;
      for (var j = 0; j < nos.length; j++) varrer(nos[j]);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener("DOMContentLoaded", function () {
    varrer(document);
  });
})();
